import { lazy } from 'react';

export const UpdatesPageLazy = lazy(() => import('./updates-page'));
